{
  "version": "9.18.6 | 26.02.2026",
  "xTranslate": "2.22.17"
}
